import { useRef, useContext } from 'react';
import { ContainerContext } from './common';
function useDependenciesInternal(tokens, optional) {
    const ref = useRef(null);
    const container = useContext(ContainerContext);
    if (!ref.current) {
        ref.current = tokens.map(s => {
            if (optional) {
                if (container.isBound(s)) {
                    return container.get(s);
                }
                return undefined;
            }
            return container.get(s);
        });
    }
    return ref.current;
}
export function useDependencies(...tokens) {
    return useDependenciesInternal(tokens, false);
}
export function useOptionalDependencies(...tokens) {
    return useDependenciesInternal(tokens, true);
}
//# sourceMappingURL=use-dependencies.js.map